import { SagittaScoreAreaDto } from '../dto/sagitta-score-area-dto';
import { SectionId } from './section-id-enum';

export const SAGITTA_SCORE_CONFIG: SagittaScoreAreaDto[] = [
  {
    area: 'A',
    weight: 0,
    title: 'Processo',
    score: 0,
    sections: [
      {
        title: 'A1) Screening negativo minimo',
        id: SectionId.a1ScreeningNegativoMinimo,
        weight: 100,
      },

      {
        title: 'A2) Onboarding',
        id: SectionId.a2Onboarding,
        weight: 100,
      },

      {
        title: 'A3) Analisi Delle Garanzie / Due Diligence',
        id: SectionId.a3AnalisiDelleGaranzieDueDiligence,
        weight: 100,
      },

      {
        title: 'Identificazione del settore',
        id: SectionId.identificazioneDelSettore,
        weight: 0,
      },
    ],
  },

  {
    area: 'B',
    weight: 7.5,

    title: 'Legal Structure',
    score: 14,
    sections: [
      {
        title: 'B1) Tipologia Di Procedura',
        id: SectionId.b1TipologiaDiProcedura,
        weight: 100,
      },
    ],
  },

  {
    area: 'C',
    weight: 57.5,

    title: 'Analisi controparte',
    score: 3.52,
    sections: [
      {
        title:
          'C1) Calcolo KRI (dove previsto: 60% ultimo anno storico e 40% primo anno di piano)',
        id: SectionId.c1CalcoloKriDovePrevisto,
        weight: 47.5,
      },
      {
        title: 'C2) Verifica regolarità debiti tributari e previdenziali',
        id: SectionId.c2VerificaRegolaritaDebitiTributariEPrevidenziali,
        weight: 5,
      },
      {
        title: 'C3) Valutazione scostamento rispetto al piano',
        id: SectionId.c3ValutazioneScostamentoRispettoAlPiano,
        weight: 20,
      },
      {
        title: 'C4) Presenza pareri esterni',
        id: SectionId.c4PresenzaPareriEsterni,
        weight: 2.5,
      },
      {
        title: 'C5) Analisi del business',
        id: SectionId.c5AnalisiDelBusiness,
        weight: 25,
      },
      {
        title: 'Regolarità dei pagamenti',
        id: SectionId.regolaritaDeiPagamenti,
        weight: 100,
      },
    ],
  },

  {
    area: 'D',
    weight: 35,
    title: 'Recovery',
    score: 3.52,
    sections: [
      {
        title: 'D1) Ranking Giuridico',
        id: SectionId.d1RankingGiuridico,
        weight: 12.5,
      },
      {
        title: 'D2) Ranking Contrattuale',
        id: SectionId.d2RankingContrattuale,
        weight: 12.5,
      },
      {
        title: 'D3) Finalità del finanziamento',
        id: SectionId.d3FinalitaDelFinanziamento,
        weight: 5,
      },
      {
        title: 'D4) Recovery analysis',
        id: SectionId.d4RecoveryAnalysis,
        weight: 55,
      },
      {
        title:
          "D5) Velocità e sicurezza di recupero dell'escussione della garanzia",
        id: SectionId.d5VelocitaESicurezzaDiRecuperoDellEscussioneDellaGaranzia,
        weight: 15,
      },
    ],
  },

  {
    area: 'E',
    weight: 0,
    title: 'ESG (Opzionale)',
    score: 3.52,
    sections: [
      {
        title: 'E1) Criteri Di Erogazione Esg',
        id: SectionId.e1CriteriDiErogazioneEsg,
        weight: 100,
      },
      {
        title: 'E2) Due Diligence Esg',
        id: SectionId.e2DueDiligenceEsg,
        weight: 100,
      },
      {
        title: 'E3) Rating Esg',
        id: SectionId.e3RatingEsg,
        weight: 100,
      },
    ],
  },
];
